module.exports = __webpack_public_path__ + "img/image35.c47be51d.jpg";